// By setting a default currency, we bypass an error that may happen when the currency is undefined;
// "Uncaught TypeError: Currency code is required with currency style."

export const DEFAULT_CURRENCY = 'USD';

export const formatPrice = (
  currency: string | undefined | null,
  price: number | string | null | undefined
) => {
  const priceFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency ? currency : DEFAULT_CURRENCY
  });

  return priceFormatter.format(Number(price));
};
